import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FailureIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-failure-new.svg';

interface VendorDetailsRequestFormFailureProps {
    businessName: string
}

export const VendorDetailsRequestFormFailure = ({ businessName } : VendorDetailsRequestFormFailureProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center h-full justify-center pb-[30px]'>
      <FailureIcon />
      <p className='font-metricRSemibold text-[18px] text-bw08 text-center mt-[26px] '>{t('ASK_VENDOR.PAYMENT_FAILURE.TITLE')}</p>
      <p className='font-metricR text-[16px] text-bw08 text-center mt-[14px] max-w-[315px]'>{t('ASK_VENDOR.PAYMENT_FAILURE.MESSAGE', { businessName })}</p>
    </div>
  );
};
